import { Image } from '@app/components'
import React from 'react'
import { CSSProperties } from 'styled-components'

export const MetamaskIcon = ({ style }: { style?: CSSProperties }) => {
  return <Image preview={false} src="../images/metamask.png" style={style} />
}
